import { Routes } from '@angular/router';
import { ShellComponent } from './core/layout/shell/shell';

export const routes: Routes = [
  {
    path: '',
    component: ShellComponent,
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', loadComponent: () => import('./features/dashboard/dashboard.page').then(m => m.DashboardPage), data: { animation: 'Dashboard' } },
      { path: 'documents', loadComponent: () => import('./features/documents/documents.page').then(m => m.DocumentsPage), data: { animation: 'Documents' } },
      { path: 'workflows', loadComponent: () => import('./features/workflows/workflows.page').then(m => m.WorkflowsPage), data: { animation: 'Workflows' } },
      { path: 'memos', loadComponent: () => import('./features/memos/memos.page').then(m => m.MemosPage), data: { animation: 'Memos' } },
      { path: 'payments', loadComponent: () => import('./features/payments/payments.page').then(m => m.PaymentsPage), data: { animation: 'Payments' } },
      { path: 'directory', loadComponent: () => import('./features/directory/directory.page').then(m => m.DirectoryPage), data: { animation: 'Directory' } },
    ],
  },
];
